import AppActions from 'bukku/redux/App/actions';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { AppModalType } from '../../../../../enums/AppModalType';
import { CookieKey } from '../../../../../enums/CookieKey';
import { MomentFormatEnums } from '../../../../../enums/MomentEnums';
import { CookiesHelper } from '../../../../../helpers/CookiesHelper';
import { usePrevious } from '../../../../../helpers/useReadStateSuccess';
import { isDebugIdleModal } from '../../constants';

const {
    openAppModal,
} = AppActions;
const selectorFn = state => ({
    isIdleModalVisible: state.App.appModal[AppModalType.IDLE_MODAL].isVisible,
    isExpiredModalVisible: state.App.appModal[AppModalType.SESSION_EXPIRED_MODAL].isVisible,
    lastApiCallTime: state.Logger.lastApiCallTime,
    isSessionLockEnabled: state.User.user?.session_idle_lock,
});

/**
 * This function will check if user is idle (from cookie) every time there is an api call
 * - also handles session_idle_lock change in user profile to disable / enable this function
 * @param {*} resetCookieAndCloseModal
 */
export const useIdleApiCallListener = resetCookieAndCloseModal => {
    const {
        isExpiredModalVisible,
        lastApiCallTime,
        isSessionLockEnabled,
    } = useSelector(selectorFn, shallowEqual);
    const dispatch = useDispatch();

    // 1. Handles session_idle_lock change in user profile
    const prevIsSessionLockEnabled = usePrevious(isSessionLockEnabled);
    useEffect(() => {
        if (isSessionLockEnabled && prevIsSessionLockEnabled === false) {
            if (isDebugIdleModal)
                console.log('aaa debug InactiveModalV2 - useIdleApiCallListener - set cookie');
            // reset cookie and close modal if session_idle_lock is enabled
            resetCookieAndCloseModal();
        }

        if (!isSessionLockEnabled && prevIsSessionLockEnabled === true) {
            if (isDebugIdleModal)
                console.log('aaa debug Inactive Modal V2 - useIdleApiCallListener - clear cookie');
            // clear cookie if session_idle_lock is disabled
            CookiesHelper.removeCookie(CookieKey.session_idle);
        }
    }, [isSessionLockEnabled, prevIsSessionLockEnabled, resetCookieAndCloseModal]);

    // 2. THE ACTUAL API CALL LISTENER
    useEffect(() => {
        // check difference between lastApiCallTime and current time
        const idleTimeoutTime = CookiesHelper.getCookie(CookieKey.session_idle);
        const diff = dayjs(idleTimeoutTime).diff(dayjs(), 'second');
        const isIdle = diff <= 0;

        if (isDebugIdleModal) {
            console.log('aaa debug Inactive Modal V2 - useEffect apiCall Listener', {
                diff,
                idleTimeoutTime,
                timeNow: dayjs().format(MomentFormatEnums.date_time),
                isIdle,
            });
        }

        if (isSessionLockEnabled && idleTimeoutTime && isIdle && !isExpiredModalVisible)
            dispatch(openAppModal(AppModalType.IDLE_MODAL));
    }, [dispatch, lastApiCallTime, isExpiredModalVisible, isSessionLockEnabled]);
};
